import { useRouter } from "@tanstack/react-router";
import { ArrowRight } from "@untitled-ui/icons-react";
import { useTranslation } from "react-i18next";

import NotFoundImage from "@/assets/images/not-found.png";

import Button from "../forms/Button";
import Text from "../text/Text";

export default function NotFound() {
  const { t } = useTranslation("core.shared");
  const router = useRouter();
  return (
    <div className="flex h-full flex-col items-center px-24 py-20">
      <div className="flex h-full w-full max-w-[1280px] items-center justify-between gap-12 px-8">
        <div className="flex flex-col gap-12">
          <Text weight="semibold" color="primary">
            {t("Error 404")}
          </Text>
          <Text size="6xl" weight="semibold">
            {t("Page not found")}
          </Text>
          <Text size="xl" weight="normal" color="gray">
            {t("Sorry, the page you are looking for does not exist")}
            <br />
            {t("Here are some useful links for you")}:
          </Text>
          <div className="flex gap-3">
            <Button
              color="secondary-gray"
              size="xl"
              startIcon={<ArrowRight className="h-5 w-5" />}
              onClick={() => router.history.back()}
            >
              {t("Back")}
            </Button>
            <Button size="xl" link={{ to: "/" }}>
              {t("Home")}
            </Button>
          </div>
        </div>
        <img src={NotFoundImage} />
      </div>
    </div>
  );
}
